import React from 'react';
import './DetailPageBanner.css';

const DetailPageBanner = ({ header, content, lastWord }) => {
    return (
        <div className="banner-container">
            {header && <span>{header}</span>}
            <p>{content}</p>
            {lastWord && <p><br/>{lastWord}</p>}
        </div>
    );
};

export default DetailPageBanner; 